import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import List from "app/stores/list"

export default class Store {
  @observable total = ''
  @observable chartData = {
    data: [],
    size: [],
    report: [],
    flow: []
  }

  @action getChartData = () => {
    return request.get(`${config.backend}/accounts/balance/dashboard`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.chartData = res
      })
  }

  @action getBalance = () => {
    return request.get(`${config.backend}/accounts/balance`)
      .checkToken()
      .commonDispose()
      .then(res => {
        this.total = res.total
      })
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "accounts/statistic")
    return store
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/preview/dashboard.js